//CSS
import './css/Text.css';


function Text({content}){
    return(
        <p className='TextContent'>{content}</p>
    )
}


export default Text;